import React, { memo, useEffect, useRef, useState } from "react";
import { Area, AreaText } from "./styles";
import { QuestionnaireProps } from "../../../../../interfaces/pacientes.interface";
import { useDispatch, useSelector } from "react-redux";
import { PacAvalActions } from "../../../../../store/ducks/manage_pac_aval";
import { TextsProps } from "../../../../../database/txt.interface";

interface questionProps {
	item: QuestionnaireProps;
	autoFocus?: boolean;
	type?: string;
}

const TextArea: React.FC<questionProps> = ({ item,type, autoFocus = false }) => {
	const dispatch = useDispatch();
	const array_respostas = useSelector(
		(state: any) => state.pac_aval.array_respostas
	);
	const array_resposta = useSelector(
		(state: any) => state.pac_aval.array_resposta
	);
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);

	const [value, setValue] = useState("");
	const textAreaRef = useRef<HTMLTextAreaElement>(null);

	const isEditable = array_respostas.find((element: {	QUESTIONARIO_LABEL: string; QUESTIONARIO_RESPOSTA: string[]})=>
		element.QUESTIONARIO_LABEL === item.QUESTIONARIO_LABEL && 
		element.QUESTIONARIO_RESPOSTA[0] ==  item?.QUESTIONARIO_PERGUNTA_CONDICAO
	)

	useEffect(() => {
		const el = textAreaRef.current;
		
		if (el && type === 'ICP') {
			el.style.height = 'auto'; 
			const scroll = Number( el.scrollHeight) - 10
			el.style.height = String(scroll)+ 'px'; 
		}
		
	}, [value, type]);

	useEffect(() => {
		const valor = array_respostas?.filter(
			(e: any) => e?.QUESTIONARIO_LABEL === item?.QUESTIONARIO_LABEL
		);
		if (valor.length === 1 && type !== 'ICP' ) {
			setValue(valor[0].QUESTIONARIO_RESPOSTA[0]);
		}
		
	}, []);
	useEffect(()=>{
		if(type === 'ICP' ){
			const persistValue = array_respostas?.filter(
				(e: any) => e?.QUESTIONARIO_LABEL === item?.QUESTIONARIO_PERGUNTA_COMPLEMENTO![0]?.QUESTIONARIO_LABEL!
			);
			if(persistValue.length > 0){
				setValue(persistValue[0].QUESTIONARIO_RESPOSTA[0]);
			}
		}
	},[])

	useEffect(()=>{
		if(!isEditable){
			setValue("")
			const dataObj = {
				QUESTIONARIO_LABEL: `${item?.QUESTIONARIO_PERGUNTA_COMPLEMENTO![0]?.QUESTIONARIO_LABEL!}`,
				QUESTIONARIO_RESPOSTA: [""],
			};
			const change_value = array_respostas?.filter(
				(e: any) => e?.QUESTIONARIO_LABEL !== item?.QUESTIONARIO_PERGUNTA_COMPLEMENTO![0]?.QUESTIONARIO_LABEL!
			);
			dispatch(PacAvalActions.set_array_respostas([...change_value, dataObj]));
		}
	},[isEditable])

	useEffect(()=>{
		if(type === 'ICP' && value.length > 0){
			const dataObj = {
				QUESTIONARIO_LABEL: `${item?.QUESTIONARIO_PERGUNTA_COMPLEMENTO![0]?.QUESTIONARIO_LABEL!}`,
				QUESTIONARIO_RESPOSTA: [value],
			};

			const change_value = array_respostas?.filter(
				(e: any) => e?.QUESTIONARIO_LABEL !== item?.QUESTIONARIO_PERGUNTA_COMPLEMENTO![0]?.QUESTIONARIO_LABEL!
			);
			dispatch(PacAvalActions.set_array_respostas([...change_value, dataObj]));

		}

	},[value])

	const handleTextInput = (item: QuestionnaireProps, text: string) => {
		if (text != "") {
			const dataObj = {
				QUESTIONARIO_LABEL: `${item.QUESTIONARIO_LABEL}`,
				QUESTIONARIO_RESPOSTA: [text],
			};
			const new_array = array_respostas.filter(
				(e: any) => e.QUESTIONARIO_LABEL !== item.QUESTIONARIO_LABEL
			);
			const new_array_resposta = array_resposta.filter(
				(e: any) => e.QUESTIONARIO_LABEL !== item.QUESTIONARIO_LABEL
			);
			dispatch(PacAvalActions.set_array_respostas([...new_array, dataObj]));
			dispatch(
				PacAvalActions.set_array_resposta([...new_array_resposta, dataObj])
			);
		} else {
			const new_array = array_respostas.filter(
				(e: any) => e.QUESTIONARIO_LABEL !== item.QUESTIONARIO_LABEL
			);
			const new_array_resposta = array_resposta.filter(
				(e: any) => e.QUESTIONARIO_LABEL !== item.QUESTIONARIO_LABEL
			);
			dispatch(PacAvalActions.set_array_respostas([...new_array]));
			dispatch(PacAvalActions.set_array_resposta([...new_array_resposta]));
		}
	};

	return (
		<Area 	type={type}>
			<AreaText
				onChange={(e) => setValue(e.target.value)}
				ref={textAreaRef}
				value={value}
				onBlur={() =>	type !== 'ICP' ?  handleTextInput(item, value) : {}}
				placeholder={type == 'ICP' ? current_language?.outros_icp: `${item.QUESTIONARIO_PERGUNTA_OPCOES}`}
				autoFocus={autoFocus}
				maxLength={type == 'ICP' ? 300 : 255}
				type={type}
			/>
			<div className="contador">{value.length}/{type == 'ICP' ? 300 : 255}</div>
		</Area>
	);
};

export default memo(TextArea);
